import $ from "jquery";
import plugin from '../../lib/plugin';

const PLUGIN_NAME = 'app.core/modules/disable-on-submit';
const ELEMENT_SELECTOR = '[data-disable-on-submit]';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--disable-on-submit" */ './disable-on-submit'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/disable-on-submit/index.js